<template>
  <div class="account-management">
    <el-card class="search-card">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="收款人姓名">
          <el-input v-model="searchForm.realName" placeholder="请输入收款人姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="银行账号">
          <el-input v-model="searchForm.bankAccount" placeholder="请输入银行账号" clearable></el-input>
        </el-form-item>
        <el-form-item label="用户手机号">
          <el-input v-model="searchForm.phone" placeholder="请输入用户手机号" clearable></el-input>
        </el-form-item>
        <el-form-item label="群昵称">
          <el-input v-model="searchForm.groupNickname" placeholder="请输入群昵称" clearable></el-input>
        </el-form-item>
        <el-form-item label="上架代码">
          <el-input v-model="searchForm.shelfCode" placeholder="请输入上架代码" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择" clearable>
            <el-option label="正常" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" icon="el-icon-search">查询</el-button>
          <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="table-card">
      <div slot="header" class="clearfix">
        <span>账户列表</span>
      </div>

      <el-table :data="tableData" border stripe v-loading="tableLoading">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="userId" label="用户ID" width="80"></el-table-column>
        <el-table-column prop="nickname" label="用户昵称" width="120"></el-table-column>
        <el-table-column prop="groupNickname" label="群昵称" width="120">
          <template slot-scope="scope">
            {{ scope.row.groupNickname || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="shelfCode" label="上架代码" width="120">
          <template slot-scope="scope">
            {{ scope.row.shelfCode || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="用户手机号" width="130">
          <template slot-scope="scope">
            {{ scope.row.phone || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="realName" label="收款人姓名" width="100"></el-table-column>
        <el-table-column prop="idCard" label="身份证号" width="180">
          <template slot-scope="scope">
            {{ scope.row.idCard || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="bankName" label="银行名称" width="120"></el-table-column>
        <el-table-column prop="bankAccount" label="银行账号" width="180">
          <template slot-scope="scope">
            {{ scope.row.bankAccount || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
              {{ scope.row.status === 1 ? '正常' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleStatus(scope.row)">
              {{ scope.row.status === 1 ? '禁用' : '启用' }}
            </el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row)" style="color: #F56C6C;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @current-change="handlePageChange"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        layout="total, prev, pager, next"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-card>

    <!-- 编辑对话框 -->
    <el-dialog title="编辑账户" :visible.sync="editDialogVisible" width="500px" @close="handleEditDialogClose">
      <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="100px">
        <el-form-item label="收款人姓名" prop="realName">
          <el-input v-model="editForm.realName" placeholder="请输入收款人姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idCard">
          <el-input v-model="editForm.idCard" placeholder="请输入收款人身份证号"></el-input>
        </el-form-item>
        <el-form-item label="银行名称" prop="bankName">
          <el-input v-model="editForm.bankName" placeholder="请输入银行名称"></el-input>
        </el-form-item>
        <el-form-item label="银行账号" prop="bankAccount">
          <el-input v-model="editForm.bankAccount" placeholder="请输入银行账号"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleEditSubmit" :loading="editSubmitLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看详情对话框 -->
    <el-dialog title="账户详情" :visible.sync="viewDialogVisible" width="600px">
      <el-descriptions :column="2" border v-if="viewData">
        <el-descriptions-item label="ID">{{ viewData.id }}</el-descriptions-item>
        <el-descriptions-item label="用户ID">{{ viewData.userId }}</el-descriptions-item>
        <el-descriptions-item label="用户昵称">{{ viewData.nickname || '-' }}</el-descriptions-item>
        <el-descriptions-item label="群昵称">{{ viewData.groupNickname || '-' }}</el-descriptions-item>
        <el-descriptions-item label="上架代码">{{ viewData.shelfCode || '-' }}</el-descriptions-item>
        <el-descriptions-item label="用户手机号">{{ viewData.phone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="收款人姓名">{{ viewData.realName }}</el-descriptions-item>
        <el-descriptions-item label="身份证号">{{ viewData.idCard || '-' }}</el-descriptions-item>
        <el-descriptions-item label="银行名称">{{ viewData.bankName }}</el-descriptions-item>
        <el-descriptions-item label="银行账号">{{ viewData.bankAccount || '-' }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="viewData.status === 1 ? 'success' : 'danger'" size="small">
            {{ viewData.status === 1 ? '正常' : '禁用' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatDate(viewData.createTime) }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ formatDate(viewData.updateTime) }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import { getAccountList, getAccount, updateAccountStatus, deleteAccount, h5UpdateAccount } from '@/api'

export default {
  name: 'AccountManagement',
  data() {
    return {
      searchForm: {
        realName: '',
        bankAccount: '',
        phone: '',
        groupNickname: '',
        shelfCode: '',
        status: null
      },
      tableData: [],
      tableLoading: false,
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      // 编辑相关
      editDialogVisible: false,
      editSubmitLoading: false,
      editForm: {
        id: null,
        realName: '',
        idCard: '',
        bankName: '',
        bankAccount: ''
      },
      editRules: {
        realName: [
          { required: true, message: '请输入收款人姓名', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入收款人身份证号', trigger: 'blur' }
        ],
        bankName: [
          { required: true, message: '请输入银行名称', trigger: 'blur' }
        ],
        bankAccount: [
          { required: true, message: '请输入银行账号', trigger: 'blur' }
        ]
      },
      viewDialogVisible: false,
      viewData: null
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.tableLoading = true
      try {
        const params = {
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
          ...this.searchForm
        }
        const res = await getAccountList(params)
        this.tableData = res.data.list || []
        this.pagination.total = res.data.total || 0
      } catch (e) {
        console.error(e)
      } finally {
        this.tableLoading = false
      }
    },
    handleSearch() {
      this.pagination.pageNum = 1
      this.loadData()
    },
    handleReset() {
      this.searchForm = {
        realName: '',
        bankAccount: '',
        phone: '',
        groupNickname: '',
        shelfCode: '',
        status: null
      }
      this.handleSearch()
    },
    handlePageChange(val) {
      this.pagination.pageNum = val
      this.loadData()
    },
    async handleEdit(row) {
      try {
        const res = await getAccount(row.id)
        this.editForm = {
          id: res.data.id,
          realName: res.data.realName,
          idCard: res.data.idCard,
          bankName: res.data.bankName,
          bankAccount: res.data.bankAccount
        }
        this.editDialogVisible = true
      } catch (e) {
        console.error(e)
      }
    },
    handleEditDialogClose() {
      this.$refs.editForm.resetFields()
    },
    async handleEditSubmit() {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          this.editSubmitLoading = true
          try {
            await h5UpdateAccount(this.editForm.id, {
              realName: this.editForm.realName,
              idCard: this.editForm.idCard,
              bankName: this.editForm.bankName,
              bankAccount: this.editForm.bankAccount
            })
            this.$message.success('更新成功')
            this.editDialogVisible = false
            this.loadData()
          } catch (e) {
            console.error(e)
          } finally {
            this.editSubmitLoading = false
          }
        }
      })
    },
    async handleStatus(row) {
      const newStatus = row.status === 1 ? 0 : 1
      const text = newStatus === 1 ? '启用' : '禁用'
      try {
        await this.$confirm(`确定要${text}该账户吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await updateAccountStatus(row.id, newStatus)
        this.$message.success(`${text}成功`)
        this.loadData()
      } catch (e) {
        if (e !== 'cancel') {
          console.error(e)
        }
      }
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定要删除该账户吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await deleteAccount(row.id)
        this.$message.success('删除成功')
        this.loadData()
      } catch (e) {
        if (e !== 'cancel') {
          console.error(e)
        }
      }
    },
    async handleView(row) {
      try {
        const res = await getAccount(row.id)
        this.viewData = res.data
        this.viewDialogVisible = true
      } catch (e) {
        console.error(e)
      }
    },
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      return d.toLocaleString()
    }
  }
}
</script>

<style scoped lang="scss">
.account-management {
  padding: 20px;
}

.search-card {
  margin-bottom: 20px;
}

.table-card {
  min-height: 500px;
}
</style>
